import { services } from '../../context';

export const apiClient = () => services.axios.Axios();
